import "./ListSearchPublicationArticle.scss";
import { ListSearchPublicationArticleProps } from "/App.GeneratedTypes";
import { createSpreadableBem } from "../../../Helpers/createBem";
import { ListSearchPublicationArticleItem } from "/App.Components";
import { DesignTheme } from "/App.GeneratedEnums";

export interface Props extends ListSearchPublicationArticleProps {
  ariaLabelSearchResults?: string;
  noResultsText?: string;
  theme?: DesignTheme;
}

const ListSearchPublicationArticle = ({
  ariaLabelSearchResults,
  items,
  noResultsText,
  theme,
}: Props) => {
  const bem = createSpreadableBem("list-search-publication-article");
  const hasResults = (items?.length ?? 0) > 0;
  return (
    <div {...bem("", { "--has-no-results": !hasResults })}>
      {hasResults && (
        <section {...bem("__list")} aria-label={ariaLabelSearchResults}>
          {items?.map((item, idx) => (
            <ListSearchPublicationArticleItem key={idx} {...item} />
          ))}
        </section>
      )}
      {!hasResults && (
        <section
          {...bem("__no-results", {
            "--insight": theme === DesignTheme.Insight,
          })}
          aria-label={ariaLabelSearchResults}
        >
          {noResultsText}
        </section>
      )}
    </div>
  );
};

export default ListSearchPublicationArticle;
